export enum PermissionField {
  VIEW = 1,
  CREATE = 2,
  UPDATE = 3,
  DELETE = 4,
  IMPORT_FILE = 5,
  EXPORT_FILE = 6
}
